import {
    Box,
    Button,
    ButtonGroup,
    Drawer,
    DrawerBody,
    DrawerCloseButton,
    DrawerContent,
    DrawerHeader,
    DrawerOverlay,
    Flex,
    FormLabel,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    useDisclosure,
} from '@chakra-ui/react';
import { Form, Formik, FormikProps } from 'formik';
import React, { useState } from 'react';
import * as Yup from 'yup';

import CustomValidationControl from '../components/CustomValidationControl';

import { JSONPreview } from '../components/JSONPreview';
import * as LBCONFIG from '../consts/LeaderboardConfig';

import { ItemDetail } from '../interfaces/IInventory';

const validationSchema = Yup.object({
    item_name: Yup.string()
        .required('Required')
        .matches(/[a-z0-9-_]+/, 'Invalid'),
});

// const TabInfo = chakra(Box, {
//     baseStyle: {
//         shadow: 'md',
//         rounded: 'md',
//         padding: '3',
//     },
// });

type AddItemFormProps = {
    initialData: ItemDetail;
    owner: string;
    onSubmit: any;
    isSaved?: boolean;
};

const AddItemForm: React.FC<AddItemFormProps> = ({
    initialData,
    owner,
    onSubmit,
    isSaved = false,
}) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const helpRef = React.useRef(null);
    const [helperContent, setHelperContent] = useState('');
    const [helperTitle, setHelperTitle] = useState('');

    const openDrawer = (title: string, content: string) => {
        onOpen();

        setHelperContent(content);
        setHelperTitle(title);
    };

    const [step, setStep] = useState(1);

    const handleNextStep = () => {
        setStep(step + 1);
    };

    const handlePrevStep = () => {
        setStep(step - 1);
    };

    const handleTabChange = (index: number) => {
        setStep(index + 1);
    };

    const buildForm = () => {
        return (
            <>
                <Formik
                    onSubmit={(values) => {
                        console.log('submitting item', values);
                        onSubmit(values);
                    }}
                    enableReinitialize={true}
                    initialValues={initialData}
                    validationSchema={validationSchema}
                    initialErrors={{}}
                >
                    {(formik: FormikProps<ItemDetail>) => {
                        return (
                            <>
                                <Box flex={1} border={'1px solid grey'}>
                                    <Box padding={5}>
                                        <Form>
                                            <Tabs index={step - 1} onChange={handleTabChange}>
                                                <TabList>
                                                    <Tab
                                                        backgroundColor={
                                                            formik.errors.item_name
                                                                ? 'red.100'
                                                                : 'transparent'
                                                        }
                                                    >
                                                        Noot Noot
                                                    </Tab>
                                                </TabList>
                                                <TabPanels>
                                                    <TabPanel>
                                                        <FormLabel>
                                                            Basic information for the item.
                                                        </FormLabel>
                                                        <CustomValidationControl
                                                            name="item_id"
                                                            value={
                                                                formik.values.item_id.indexOf(
                                                                    owner + ':',
                                                                ) >= 0
                                                                    ? formik.values.item_id.slice(
                                                                          formik.values.item_id.indexOf(
                                                                              owner + ':',
                                                                          ) + (owner + ':').length,
                                                                      )
                                                                    : formik.values.item_id
                                                            }
                                                            onChange={(st) => {
                                                                const val = st.target.value;
                                                                let prefix = owner + ':';
                                                                console.log(
                                                                    'val',
                                                                    val,
                                                                    val.indexOf(prefix),
                                                                );
                                                                if (val.indexOf(prefix) >= 0) {
                                                                    prefix = '';
                                                                }
                                                                formik.setFieldValue(
                                                                    'item_id',
                                                                    prefix + st.target.value,
                                                                );
                                                            }}
                                                            onBlur={formik.handleBlur}
                                                            label="ID"
                                                            isRequired={true}
                                                            validationMessage={
                                                                formik.touched.item_id &&
                                                                formik.errors.item_id
                                                                    ? formik.errors.item_id
                                                                    : undefined
                                                            }
                                                            help={{
                                                                onClick: () =>
                                                                    openDrawer(
                                                                        'Name',
                                                                        LBCONFIG.HELP_LEADERBOARD_NAME,
                                                                    ),
                                                            }}
                                                            readOnly={isSaved}
                                                        ></CustomValidationControl>
                                                        <CustomValidationControl
                                                            name="item_name"
                                                            value={formik.values.item_name}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            label="Name"
                                                            isRequired={true}
                                                            validationMessage={
                                                                formik.touched.item_name &&
                                                                formik.errors.item_name
                                                                    ? formik.errors.item_name
                                                                    : undefined
                                                            }
                                                            help={{
                                                                onClick: () =>
                                                                    openDrawer(
                                                                        'Name',
                                                                        LBCONFIG.HELP_LEADERBOARD_NAME,
                                                                    ),
                                                            }}
                                                        ></CustomValidationControl>
                                                        <CustomValidationControl
                                                            name="item_desc"
                                                            value={formik.values.item_desc}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            label="Description"
                                                            isRequired={true}
                                                            validationMessage={
                                                                formik.touched.item_desc &&
                                                                formik.errors.item_desc
                                                                    ? formik.errors.item_desc
                                                                    : undefined
                                                            }
                                                            help={{
                                                                onClick: () =>
                                                                    openDrawer(
                                                                        'Name',
                                                                        LBCONFIG.HELP_LEADERBOARD_NAME,
                                                                    ),
                                                            }}
                                                        ></CustomValidationControl>
                                                        <CustomValidationControl
                                                            name="item_type"
                                                            value={formik.values.item_type}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            label="Type"
                                                            isRequired={true}
                                                            validationMessage={
                                                                formik.touched.item_type &&
                                                                formik.errors.item_type
                                                                    ? formik.errors.item_type
                                                                    : undefined
                                                            }
                                                            help={{
                                                                onClick: () =>
                                                                    openDrawer(
                                                                        'Name',
                                                                        LBCONFIG.HELP_LEADERBOARD_NAME,
                                                                    ),
                                                            }}
                                                        ></CustomValidationControl>
                                                    </TabPanel>
                                                </TabPanels>
                                            </Tabs>
                                            <Flex justifyContent={'space-between'} mt={5}>
                                                <ButtonGroup>
                                                    <Button
                                                        onClick={handlePrevStep}
                                                        disabled={step === 1}
                                                        data-cy="previous-step"
                                                    >
                                                        Previous
                                                    </Button>
                                                    <Button
                                                        onClick={handleNextStep}
                                                        disabled={step === 3}
                                                        data-cy="next-step"
                                                    >
                                                        Next
                                                    </Button>
                                                </ButtonGroup>
                                                <ButtonGroup>
                                                    <Button type="submit">Save</Button>
                                                </ButtonGroup>
                                            </Flex>
                                        </Form>
                                    </Box>
                                </Box>
                                <Box flex={1}>
                                    {
                                        <JSONPreview
                                            data={formik.values}
                                            caption={'Item JSON:'}
                                            clampHeight={true}
                                        />
                                    }
                                </Box>
                            </>
                        );
                    }}
                </Formik>
                <Drawer isOpen={isOpen} placement="right" onClose={onClose} finalFocusRef={helpRef}>
                    <DrawerOverlay />
                    <DrawerContent>
                        <DrawerCloseButton />
                        <DrawerHeader>{helperTitle}</DrawerHeader>

                        <DrawerBody whiteSpace="pre-wrap">{helperContent}</DrawerBody>
                    </DrawerContent>
                </Drawer>
            </>
        );
    };

    return buildForm();
};

export default AddItemForm;
